import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },

  selectStyle: {
    [`& fieldset`]: {
      borderRadius: 25,
    },
    [`& .MuiSelect-outlined`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },
}));

const BankBeneficiaryAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [accountName, setAccountName] = useState('');
  const [accountNumber, setAccountNumber] = useState('');

  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [bankId, setBankId] = useState('');
  const [bankObj, setBankObj] = useState({});
  const [branchList, setBranchList] = useState([]);
  const [branchId, setBranchId] = useState('');
  const [branchObj, setBranchObj] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const validation = () => {
    let isError = false;

    if (!bankId.trim()) {
      console.log('bankId');
      handleSnakbarOpen('Please select bank name', 'error');
      document.getElementById('bankId').focus();
      return (isError = true);
    }
    if (!branchId.trim()) {
      console.log('branchId');
      handleSnakbarOpen('Please select branch name', 'error');
      document.getElementById('branchId').focus();
      return (isError = true);
    }
    if (!accountName.trim()) {
      console.log('accountName');
      handleSnakbarOpen('Please enter account name', 'error');
      document.getElementById('accountName').focus();
      return (isError = true);
    }
    if (!accountNumber.trim()) {
      handleSnakbarOpen('Please enter account number', 'error');
      document.getElementById('accountNumber').focus();
      return (isError = true);
    }

    console.log('finish');
    return isError;
  };
  const handleBankChange = event => {
    setBankId(event.target.value);
    getBranchList(event.target.value);
  };
  const getBankObj = item => {
    console.log('bankObj', item);
    setBankObj(item);
  };
  const getBranchObj = item => {
    console.log('branchObj', item);
    setBranchObj(item);
  };
  const handleBranchChange = event => {
    setBranchId(event.target.value);
  };
  const getBankList = async () => {
    await axios
      .get(`/api/v1/public/bank`)
      .then(function(response) {
        console.log('response', response);
        setBankList(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
  const getBranchList = async bId => {
    await axios
      .get(`/api/v1/public/bank/${bId}/branch`)
      .then(function(response) {
        console.log('branchresponse', response);
        setBranchList(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
  const clearStates = () => {
    setId('');
    setBankId('');
    setBranchId('');
    setBranchList([]);
    setAccountName('');
    setAccountNumber('');
    setStatus(false);
    setEditObj({});
  };

  const onSubmit = async e => {
    console.log('onSubmit');
    console.log('editIndexNo', editIndexNo);
    e.preventDefault();
    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      setLoading(true);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);

      try {
        if (addForm) {
          response = await axios({
            url: `/api/v1/private/beneficiary/${userId}/bank`,
            method: 'post',
            data: { accountName, accountNumber, bankId, branchId, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          let resObject = response.data.data;
          let newObject = {
            accountName: resObject.accountName,
            accountNumber: resObject.accountNumber,
            bank: bankObj,
            branch: branchObj,
            id: resObject.id,
            status: resObject.status,
          };
          setList([...list, newObject]);
          clearStates();
          console.log('newObject', newObject);
          console.log('addForm Submit', accountName, accountNumber, bankId, branchId, status);
        } else if (editForm) {
          response = await axios({
            url: `/api/v1/private/beneficiary/${userId}/bank/${id}`,
            method: 'put',
            data: { accountName, accountNumber, bankId, branchId, status },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          let resObject = response.data.data;
          let newObject = {
            accountName: resObject.accountName,
            accountNumber: resObject.accountNumber,
            bank: bankObj,
            branch: branchObj,
            id: resObject.id,
            status: resObject.status,
          };
          list[editIndexNo] = newObject;
          setRefresh(!refresh);
          console.log('editForm Submit', id, accountName, accountNumber, bankId, branchId, status);
        }
        console.log('response', response);

        closeAddDialog();
        activeAddForm();
        handleSnakbarOpen(response.data.message, 'success');
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
        setLoading(false);
      }
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  useEffect(() => {
    if (editObj.id) {
      console.log('editObj', editObj);
      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setAccountName(editObj.accountName);
      setAccountNumber(editObj.accountNumber);
      setBankId(editObj.bank.id);
      setBankObj(editObj.bank);
      setBranchId(editObj.branch.id);
      setBranchObj(editObj.branch);
      getBranchList(editObj.bank.id);
      setStatus(editObj.status);
    }
  }, [editObj]);
  const activeAddForm = () => {
    clearStates();
  };
  useEffect(() => {
    getBankList();
  }, []);

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);
  return (
    <React.Fragment>
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update Bank Beneficiary' : 'Add Bank Beneficiary'}
        </Typography>
      </div>

      <FormControl variant="outlined" size="small" fullWidth className={`${classes.marginStyle} ${classes.selectStyle}`}>
        <InputLabel id="banklabel">Select Bank</InputLabel>
        <Select labelId="banklabel" id="bankId" value={bankId} onChange={handleBankChange} label="Select Bank">
          {bankList &&
            bankList.map((item, i) => (
              <MenuItem value={item.id} key={i} onClick={() => getBankObj(item)}>
                {item.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" size="small" fullWidth className={`${classes.marginStyle} ${classes.selectStyle}`}>
        <InputLabel id="Branchlabel">Select Branch</InputLabel>
        <Select labelId="Branchlabel" id="branchId" value={branchId} onChange={handleBranchChange} label="Select Branch">
          {branchList &&
            branchList.map((item, i) => (
              <MenuItem value={item.id} key={i} onClick={() => getBranchObj(item)}>
                {item.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <TextField
        id="accountName"
        label="Account Name"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={accountName}
        onChange={e => setAccountName(e.target.value)}
      />
      <TextField
        id="accountNumber"
        label="Account Number"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={accountNumber}
        onChange={e => setAccountNumber(e.target.value)}
      />

      <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div>
      {/* <div className={classes.marginStyle}>
        {loading ? <LinearProgress /> : null}
        <Button variant="contained"  color="primary" disabled={loading} fullWidth onClick={onSubmit}>
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div> */}
      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default BankBeneficiaryAddEdit;
